import ourMesion from "../assets/images/ourMesion.png";
import ourVesion from "../assets/images/ourVesion.png";
import OurValue from "../assets/images/OurValue.png";
import Supply from "../assets/images/Supply.jpg";
import installation from "../assets/images/installation.jpg";
import Maintenance from "../assets/images/Maintenance.jpg";

export const COMPANY_INTRO_KEY =
  "We are CAF SPORTS One of the leading companies in Egypt and United Arab Emirates specialized in the field of sports construction and Artificial flooring.";

export const MISSION_VISION_ROWS = [
  {
    id: "mission",
    image: ourMesion,
    titleMode: "split",
    titlePrefix: "OUR",
    titleHighlight: "MISSION",
    titleAr: "مشروعاتنا",
    descriptionKey:
      "to be committed, credible and transparent with our customers to provide High quality products at competitive prices and take into account the specifications of the products in order to achieve the highest degree of success and continuity within the Egyptian market and United Arab Emirates market.",
    reverse: false,
  },
  {
    id: "vision",
    image: ourVesion,
    titleMode: "split",
    titlePrefix: "OUR",
    titleHighlight: "VISION",
    titleAr: "رؤيتنا",
    descriptionKey:
      "At CAF SPORTS, we aspire to revolutionize the sports flooring industry by providing innovative, high-performance solutions that suit the needs of athletes, sports facilities and fitness enthusiasts around the world. Our vision is to create cutting-edge sports flooring systems that not only enhance sports performance but prioritize For safety, durability and sustainability.",
    reverse: true,
    titleSizeClass: "text-2xl",
  },
];

export const ABOUT_EXTRA_ROWS = [
  {
    id: "value",
    image: OurValue,
    titleMode: "split",
    titlePrefix: "OUR",
    titleHighlight: "VALUE",
    titleAr: "قيمتنا",
    descriptionKey:
      "CAF Sports has a distinguished group of specialized employees policy is based on commitment, trust and credibility And transparency with customers, while providing the best products available at prices commensurate with Everyone is observing the standard specifications and the high quality of the products",
    reverse: false,
  },
];

export const SERVICE_ROWS = [
  {
    id: "supply",
    image: Supply,
    titleEn: "Supply",
    titleAr: "توريد",
    descriptionKey:
      "Caf Sports offers first class sports flooring supply solutions tailored to meet the needs of your sports facility. Our range of high-quality materials ensures optimal performance and safety for athletes of all levels. Trust Caf Sports to elevate your sports experience with reliable and durable flooring solutions.",
    reverse: false,
  },
  {
    id: "installation",
    image: installation,
    titleEn: "Installation",
    titleAr: "تركيب",
    descriptionKey:
      "At Caf Sports, we specialize in the precise installation of sports flooring. Our expert team ensures a seamless process, from preparation to completion, delivering high-quality results for your athletic facility",
    reverse: true,
    titleSizeClass: "text-2xl",
  },
  {
    id: "maintenance",
    image: Maintenance,
    titleEn: "Maintenance",
    titleAr: "صيانة",
    descriptionKey:
      "At Caf Sports, we provide expert maintenance services to keep your sports flooring in top condition. From routine cleaning to repairs, trust us to ensure your flooring remains safe and durable for years to come",
    reverse: false,
  },
];
